var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_5841",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 14,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7219 7.70158H9.14602V10.3929H12.9246C12.8638 10.7737 12.7274 11.1484 12.5277 11.4901C12.2989 11.8815 12.016 12.1795 11.726 12.4065C10.8574 13.0863 9.84472 13.2253 9.14143 13.2253C7.36483 13.2253 5.84684 12.0525 5.2592 10.4589C5.23548 10.4011 5.21974 10.3413 5.20056 10.2823C5.0707 9.87671 4.99975 9.44715 4.99975 9.00069C4.99975 8.53604 5.07658 8.09126 5.21668 7.67118C5.76926 6.0144 7.32147 4.77695 9.14271 4.77695C9.50903 4.77695 9.86179 4.82148 10.1963 4.91031C10.9608 5.11332 11.5016 5.51315 11.833 5.82941L13.8325 3.82944C12.6162 2.69042 11.0307 2.00024 9.13938 2.00024C7.6274 2.00021 6.23148 2.48137 5.08757 3.29453C4.15989 3.95399 3.39906 4.83692 2.8856 5.86235C2.408 6.81313 2.14648 7.86677 2.14648 8.99964C2.14648 10.1326 2.4084 11.1971 2.886 12.1391V12.1455C3.39046 13.1455 4.12815 14.0066 5.02474 14.663C5.80801 15.2365 7.21249 16.0002 9.13938 16.0002C10.2475 16.0002 11.2296 15.7962 12.0957 15.4138C12.7205 15.1379 13.2741 14.7781 13.7753 14.3157C14.4375 13.7047 14.9562 12.9489 15.3102 12.0794C15.6642 11.2098 15.8536 10.2265 15.8536 9.16047C15.8536 8.66399 15.8047 8.15978 15.7219 7.70153V7.70158Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_5841)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0459 9.04785C2.05317 10.1629 2.36425 11.3133 2.83511 12.242V12.2484C3.17534 12.9229 3.64033 13.4557 4.16994 13.9835L7.36869 12.7914C6.76351 12.4775 6.67116 12.2851 6.23734 11.934C5.79402 11.4774 5.46361 10.9533 5.25784 10.3386H5.24955L5.25784 10.3323C5.12247 9.92639 5.10911 9.49558 5.10412 9.04785H2.0459Z",
    fill: "url(#paint0_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14557 1.94946C8.82941 3.08393 8.95029 4.18666 9.14557 4.82828C9.51066 4.82856 9.86237 4.87301 10.1959 4.96156C10.9604 5.16457 11.5011 5.56441 11.8325 5.88067L13.8832 3.8296C12.6683 2.69195 11.2064 1.95126 9.14557 1.94946Z",
    fill: "url(#paint1_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13976 1.94067C7.58897 1.94064 6.15722 2.43415 4.98394 3.2682C4.5483 3.57788 4.14852 3.93561 3.79255 4.33342C3.69929 5.22701 4.49065 6.32531 6.05778 6.31622C6.81814 5.41285 7.9427 4.82836 9.19435 4.82836C9.19549 4.82836 9.1966 4.82846 9.19774 4.82846L9.14662 1.94088C9.14431 1.94088 9.14207 1.94067 9.13976 1.94067Z",
    fill: "url(#paint2_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2573 9.37068L12.8731 10.3419C12.8124 10.7228 12.6759 11.0975 12.4762 11.4391C12.2473 11.8306 11.9645 12.1286 11.6745 12.3555C10.8077 13.034 9.79769 13.1736 9.09458 13.1742C8.36785 14.4384 8.24044 15.0716 9.1457 16.092C10.2658 16.0911 11.2589 15.8846 12.1349 15.4978C12.768 15.2183 13.329 14.8536 13.837 14.385C14.5081 13.7658 15.0338 12.9998 15.3925 12.1186C15.7513 11.2374 15.9431 10.241 15.9431 9.16064L14.2573 9.37068Z",
    fill: "url(#paint3_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 7.6001V10.4959H15.7036C15.7622 10.0993 15.9559 9.5861 15.9559 9.16125C15.9559 8.66477 15.9071 8.05835 15.8243 7.6001H9.04395Z",
    fill: "#3086FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82348 4.2312C3.41251 4.69047 3.06141 5.20452 2.78304 5.76046C2.30545 6.71124 2.04395 7.86712 2.04395 8.99998C2.04395 9.01595 2.04524 9.03157 2.04534 9.04751C2.25685 9.46171 4.96697 9.3824 5.10357 9.04751C5.10339 9.03188 5.10167 9.01664 5.10167 9.00098C5.10167 8.53633 5.17853 8.19385 5.31862 7.77377C5.49144 7.25561 5.76204 6.77846 6.10806 6.36735C6.1865 6.26507 6.39573 6.04518 6.45677 5.91329C6.48002 5.86306 6.41455 5.83486 6.41089 5.81717C6.4068 5.7974 6.31902 5.8133 6.29936 5.79857C6.23692 5.75179 6.11328 5.72737 6.0382 5.70566C5.87773 5.65925 5.61178 5.5569 5.46407 5.45081C4.99714 5.11547 4.26847 4.7149 3.82348 4.2312Z",
    fill: "url(#paint4_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47441 5.81932C6.55715 6.48921 6.86853 5.48119 7.58841 5.16575L6.33616 2.51343C5.87551 2.71117 5.44029 2.95686 5.03648 3.24391C4.43341 3.67262 3.90086 4.19575 3.46094 4.79109L5.47441 5.81932Z",
    fill: "url(#paint5_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91439 12.5864C4.46094 13.1223 4.2334 13.1416 4.09961 14.0615C4.35527 14.3164 4.62997 14.5521 4.92187 14.7658C5.70514 15.3393 7.21181 16.103 9.13871 16.103C9.14097 16.103 9.14313 16.1028 9.1454 16.1028V13.1235C9.14394 13.1235 9.14226 13.1236 9.1408 13.1236C8.41925 13.1236 7.84265 12.93 7.25147 12.5934C7.1057 12.5104 6.84125 12.7333 6.70682 12.6336C6.52141 12.4962 6.07521 12.752 5.91439 12.5864Z",
    fill: "url(#paint6_radial_446_5841)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_446_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29492 13.0298V16.0514C8.56453 16.0836 8.84511 16.1032 9.13945 16.1032C9.43451 16.1032 9.71997 16.0877 9.99735 16.0592V13.0502C9.6865 13.1044 9.39374 13.1237 9.14154 13.1237C8.85109 13.1237 8.56862 13.0892 8.29492 13.0298Z",
    fill: "url(#paint7_linear_446_5841)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_446_5841",
    x: 2.02187,
    y: 9.02382,
    width: 5.3713,
    height: 4.98385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_446_5841",
    x: 8.92714,
    y: 1.92543,
    width: 4.9797,
    height: 3.97921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_446_5841",
    x: 3.76113,
    y: 1.91664,
    width: 5.46017,
    height: 4.42355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_446_5841",
    x: 8.48378,
    y: 9.13662,
    width: 7.4836,
    height: 6.97945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_446_5841",
    x: 9.01992,
    y: 7.57607,
    width: 6.96017,
    height: 2.94381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_446_5841",
    x: 2.01992,
    y: 4.20717,
    width: 4.46603,
    height: 5.14596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_446_5841",
    x: 3.292,
    y: 2.34449,
    width: 4.4658,
    height: 3.86887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0844666,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_446_5841",
    x: 4.07558,
    y: 12.5504,
    width: 5.09396,
    height: 3.57662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_446_5841",
    x: 8.27089,
    y: 13.0058,
    width: 1.75021,
    height: 3.12154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0120145,
    result: "effect1_foregroundBlur_446_5841"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30466 13.8785) rotate(-92.3395) scale(6.97777 10.2495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141612,
    stopColor: "#1ABD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247515,
    stopColor: "#6EC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#8AC502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#A2C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445673,
    stopColor: "#C8C903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#EBCB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#F7CD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699345,
    stopColor: "#FDCD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FDCE05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FFCE0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.83727 -1.18741e-05 -6.79897e-06 6.24707 13.6913 5.73226)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408458,
    stopColor: "#FB4E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0507 1.03639) rotate(151.02) scale(7.74744 10.5132)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#FF4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#FF4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FF473F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#FF5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FF5B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FF6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.24645 15.1859) rotate(-127.454) scale(20.2111 7.46044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131546,
    stopColor: "#0CBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209784,
    stopColor: "#0BB86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297297,
    stopColor: "#09B479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396257,
    stopColor: "#08AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477124,
    stopColor: "#0AA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568425,
    stopColor: "#0D9CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667385,
    stopColor: "#1893DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768727,
    stopColor: "#258BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858506,
    stopColor: "#3086FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.54515 3.26294) rotate(96.6178) scale(7.54739 10.4356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF8A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FFA312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#FFB60C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FECF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#FECF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.32229 3.18534) rotate(132.119) scale(3.74872 10.5734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315904,
    stopColor: "#FF4C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603818,
    stopColor: "#FF692C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726837,
    stopColor: "#FF7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884534,
    stopColor: "#FF8D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_446_5841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0495 16.9648) rotate(-151.02) scale(7.74744 10.5132)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#0FBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#0FBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#12BC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#28BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#38C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#52C218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#67C30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_446_5841",
    x1: 8.29492,
    y1: 14.5665,
    x2: 9.99735,
    y2: 14.5665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA65"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelogo);
export default __webpack_public_path__ + "static/media/Google logo.749fe8875ff251fd5d317ee38e753d17.svg";
export { ForwardRef as ReactComponent };